export default "__VITE_ASSET__AXpHjhZi__"